import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { Loader2 } from "lucide-react";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { TenantProvider } from "@/context/TenantContext";
import LoginPage from "@/pages/LoginPage";
import HubPage from "@/pages/HubPage";
import ModulePage from "@/pages/ModulePage";
import InboundChatPage from "@/pages/inbound-chat/InboundChatPage";
import OutboundSalesPage from "@/pages/outbound-sales/OutboundSalesPage";
import InboundVoicePage from "@/pages/inbound-voice/InboundVoicePage";
import AdherencePage from "@/pages/adherence/AdherencePage";
import QualityPage from "@/pages/quality/QualityPage";
import HcForecastingPage from "@/pages/hc-forecasting/HcForecastingPage";
import SettingsPage from "@/pages/SettingsPage";
import AhtPage from "@/pages/aht/AhtPage";
import ReportsPage from "@/pages/ReportsPage";

const savedTheme = localStorage.getItem("mieruka_theme");
const prefersLight = window.matchMedia?.("(prefers-color-scheme: light)").matches;
if (savedTheme === "light" || (!savedTheme && prefersLight)) {
  document.documentElement.classList.add("light");
}

const Loading = () => (
  <div className="flex min-h-screen items-center justify-center bg-appbg text-thcyan">
    <Loader2 className="h-8 w-8 animate-spin" />
  </div>
);

const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

const LoginRoute = () => {
  const { user, loading } = useAuth();
  if (loading) return <Loading />;
  if (user) return <Navigate to="/" replace />;
  return <LoginPage />;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <TenantProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<LoginRoute />} />
              <Route path="/" element={<Protected><HubPage /></Protected>} />
              <Route path="/module/inbound-chat" element={<Protected><InboundChatPage /></Protected>} />
              <Route path="/module/outbound-sales" element={<Protected><OutboundSalesPage /></Protected>} />
              <Route path="/module/inbound-voice" element={<Protected><InboundVoicePage /></Protected>} />
              <Route path="/module/adherence" element={<Protected><AdherencePage /></Protected>} />
              <Route path="/module/quality" element={<Protected><QualityPage /></Protected>} />
              <Route path="/module/hc-forecasting" element={<Protected><HcForecastingPage /></Protected>} />
              <Route path="/module/:slug" element={<Protected><ModulePage /></Protected>} />
              <Route path="/settings" element={<Protected><SettingsPage /></Protected>} />
              <Route path="/reports" element={<Protected><ReportsPage /></Protected>} />
              <Route path="/aht" element={<Protected><AhtPage /></Protected>} />
              <Route path="/users" element={<Navigate to="/settings" replace />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </TenantProvider>
      </AuthProvider>
      <Toaster position="top-right" theme="system" richColors toastOptions={{ style: { fontFamily: "Manrope, sans-serif" } }} />
    </div>
  );
}

export default App;
